import React, { type FC } from 'react';
import type { TablePaginationConfig } from 'antd/es/table';
import { Table } from 'antd';
import { format, parse, isValid } from 'date-fns';

export namespace NotesList {
  type Note = {
    ID: number;
    datetime: string;
    user: {
      name: string;
    };
    note_type: {
      name: string;
    };
    notes: string;
  };

  type PaginationMetadata = {
    total: number;
    current_page: number;
    per_page: number;
    onChange: (page: number, pageSize: number) => void;
  };

  export type Props = {
    notes?: Note[];
    paginationMetadata?: PaginationMetadata;
  };

  const columnsDefinition = [
    {
      key: 'createdTime',
      title: 'Created',
      dataIndex: 'datetime',
      render: (datetime: string) => {
        const parsedDate = parse(datetime, 'yyyy-MM-dd HH:mm:ss', new Date());
        return isValid(parsedDate) ? format(parsedDate, 'h:mmaaa dd-MM-yyyy') : '';
      },
      width: 150,
    },
    {
      key: 'createdBy',
      title: 'Created By',
      dataIndex: ['user', 'name'],
      render: (text: string) => <span data-dd-privacy="mask">{text}</span>,
      width: 150,
    },
    {
      key: 'noteLinks',
      title: 'Note Links',
      render: () => 'N/A',
      width: 150,
    },
    {
      key: 'noteType',
      title: 'Note Type',
      dataIndex: ['note_type', 'name'],
      width: 150,
    },
    {
      key: 'note',
      title: 'Note',
      dataIndex: 'notes',
    },
    {
      key: 'actions',
      title: 'Actions',
      render: () => <div></div>,
      width: 80,
    },
  ];

  export const $: FC<Props> = ({ notes, paginationMetadata: meta }) => {
    const paginationProps: TablePaginationConfig | undefined = meta
      ? {
          total: meta.total,
          current: meta.current_page,
          pageSize: meta.per_page || 10,
          showTotal: () => <>Total {meta.total} items</>,
          showSizeChanger: true,
          onShowSizeChange: meta.onChange,
          onChange: meta.onChange,
        }
      : undefined;

    return (
      <Table
        rowKey={(record) => record.ID}
        columns={columnsDefinition}
        dataSource={notes}
        pagination={paginationProps}
        locale={{
          emptyText: 'No notes available.',
        }}
      />
    );
  };
}
